/* tslint:disable */
/* eslint-disable */
export enum WorkAbsenceDayPartEnum {
  Full = 'full',
  Morning = 'morning',
  Afternoon = 'afternoon'
}
